import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Link } from 'react-scroll';
import styles from './styles.module.css';

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

export default function Hero() {
  const { t } = useTranslation('landing');

  return (
    <section className={styles.hero}>
      <motion.div
        className={styles.inner}
        initial="hidden"
        animate="visible"
        variants={fadeUp}
      >
        <div>
          <div className={styles.badge}>
            <span className={styles.dotPulse}></span>
            {t('hero.badge')}
          </div>
          <h1 className={styles.title}>
            {t('hero.titleLine1')}<br />
            <em>{t('hero.titleLine2')}</em><br />
            {t('hero.titleLine3')}
          </h1>
          <p className={styles.subtitle}>{t('hero.subtitle')}</p>
          <div className={styles.buttons}>
            <Link
              to="cta"
              smooth
              duration={500}
              offset={-64}
              className={styles.btnPrimary}
            >
              {t('hero.btnPrimary')}
            </Link>
            <Link
              to="how"
              smooth
              duration={500}
              offset={-64}
              className={styles.btnSecondary}
            >
              {t('hero.btnSecondary')}
            </Link>
          </div>
          <div className={styles.metrics}>
            <div className={styles.metric}>
              <strong>{t('hero.metrics.price.value')}</strong>
              <span>{t('hero.metrics.price.label')}</span>
            </div>
            <div className={styles.metric}>
              <strong>{t('hero.metrics.time.value')}</strong>
              <span>{t('hero.metrics.time.label')}</span>
            </div>
            <div className={styles.metric}>
              <strong>{t('hero.metrics.impl.value')}</strong>
              <span>{t('hero.metrics.impl.label')}</span>
            </div>
          </div>
        </div>
        <div className={styles.mock}>
          <div className={styles.mockBar}>
            <div className={styles.mockDot} style={{ background: '#e74c3c' }}></div>
            <div className={styles.mockDot} style={{ background: '#f39c12' }}></div>
            <div className={styles.mockDot} style={{ background: '#27ae60' }}></div>
            <span className={styles.mockUrl}>{t('hero.mock.url')}</span>
            <span className={styles.mockPill}>{t('hero.mock.pill')}</span>
          </div>
          <div className={styles.mockItem}>
            <div className={styles.mockName}>{t('hero.mock.item1.name')}</div>
            <div className={styles.mockMeta}>{t('hero.mock.item1.meta')}</div>
            <div className={styles.progWrap}>
              <div className={styles.progRow}>
                <span>{t('hero.mock.item1.progress')}</span>
                <span style={{ color: '#5BA4CF' }}>{t('hero.mock.item1.percent')}</span>
              </div>
              <div className={styles.progBar}>
                <div className={styles.progFill}></div>
              </div>
            </div>
          </div>
          <div className={styles.mockItem} style={{ opacity: 0.52 }}>
            <div className={styles.mockName}>{t('hero.mock.item2.name')}</div>
            <div className={styles.mockMeta}>{t('hero.mock.item2.meta')}</div>
            <div className={styles.mockBtns}>
              <div className={`${styles.mockBtn} ${styles.pdfBtn}`}>{t('hero.mock.item2.pdf')}</div>
              <div className={`${styles.mockBtn} ${styles.wordBtn}`}>{t('hero.mock.item2.word')}</div>
            </div>
          </div>
          <div className={styles.mockFooter}>
            {t('hero.mock.footerPrefix')} <strong>{t('hero.mock.footerTime')}</strong>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
